import React from 'react';
import { withTranslation } from 'config/i18n';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TransactionHistoryTable from 'components/ownerPages/earningsAndPayouts/transactionHistory/Table';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1.5),
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(21),
    },
  },
  subtitle: {
    fontWeight: 600,
  },
  description: {
    fontSize: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(1),
  },
  button: {
    color: theme.palette.info.main,
    borderColor: theme.palette.info.main,
  },
}));

const TransactionHistory = ({
  t, data, page, rowsPerPage, count, onChangePage, onChangeRowsPerPage,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.title}>
        {t('fe_earnings_and_payouts_page:transaction_history.title')}
      </Typography>
      <Typography variant="h5" className={classes.description}>
        {t('fe_earnings_and_payouts_page:transaction_history.description')}
      </Typography>
      <TransactionHistoryTable
        data={data}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    </div>
  );
};

export default withTranslation(['fe_earnings_and_payouts_page'])(TransactionHistory);
